const RECENT_ACCOUNT_MAX_AGE_MS = 24 * 60 * 60 * 1000;

export const isRecentAccount = (createdAt: Date | null, now: number): boolean =>
  createdAt !== null && now - createdAt.getTime() <= RECENT_ACCOUNT_MAX_AGE_MS;
